import { Entity } from "../Entity";
import { GraphicItemService } from "../row/GraphicItemService";
import { PitService } from "./PitService";
import { graphicEvents, ON_SELECT_PIT, ON_UNSELECT_PIT } from "../../GraphicEvents";
import { Application, Container, Text, Sprite, Loader } from 'pixi.js';
import { EntityLabel } from "../EntityLabel";

export class Pit extends Entity {

    constructor({
        id = null,
        category = null,
        container,
        graphicItems,
        width,
        height
    }) {
        super({
            id,
            container,
            graphicItems,
            type: 'pit',
            enableCacheAsBitmap: true
        });

        this.category = category;
        this.width = width;
        this.height = height;
        this.countTicket = 0;

        this.isEnable = true;
        this.graphicItemsEvents = [];
        this.entityLabel = new EntityLabel(this, '', EntityLabel.DISPLAY.LEFT);

        graphicEvents.on(ON_SELECT_PIT, data => {
            if (data.pitId === this.id) this.addTicket();
        });
        graphicEvents.on(ON_UNSELECT_PIT, data => {
            if (data.pitId === this.id) this.removeTicket();
        });
    }

    draw(level = null, graphicsContainer = this.container) {
        super.draw(level, graphicsContainer);
        this.ticketsContainer = new Container();

        const resource = Loader.shared.resources['ticket'];

        this.countText = new Text('x0', {fontSize: 22});
        this.ticketsContainer.addChild(this.countText);

        if (resource) {
            this.countIcon = new Sprite(resource.texture);

            this.countText.x = this.countIcon.width + 10;
            this.countText.y = this.countIcon.height / 2 - (this.countText.height / 2);

            this.ticketsContainer.addChild(this.countIcon);
        }

        this.ticketsContainer.x = this.container.width / 2 - (this.ticketsContainer.width / 2);
        this.ticketsContainer.y = this.container.height / 2 - (this.ticketsContainer.height / 2);

        this.entityLabel.draw();
    }

    destroy(graphicsContainer = this.container) {
        super.destroy(graphicsContainer);
        this.entityLabel.destroy();
    }

    clone() {
        return PitService.createFromProps(this.getProps())
    }

    getProps() {
        return {
            ...super.getProps(),
            width: this.width,
            height: this.height,
            categoryId: this.category ? this.category.id : null
        };
    }

    updateFromProps(rowProps, bindProps = null) {
        super.updateFromProps(
            rowProps,
            bindProps,
            props => PitService.createFromProps(props),
            newEntity => {
                this.height = newEntity.height;
                this.width = newEntity.width;
                if (this.category) newEntity.setCategory(this.category);
            }
        )
    }

    setCategory(category) {
        this.category = category;

        this.graphicItems.forEach(graphicItem =>
            GraphicItemService.setGraphicItemColor(graphicItem, category.color)
        );
    }

    selectSeat() {
        GraphicItemService.hover(this.graphicItems);
    }

    disableSeat() {
        GraphicItemService.setGraphicItemColor(this.graphicItems[0], this.category.color, 0.15);
        this.graphicItems.interactive = true;
        this.graphicItems.cursor = 'not-allowed';
    }

    enableSeat() {
        this.graphicItems.cursor = 'pointer';
        GraphicItemService.setGraphicItemColor(this.graphicItems[0], this.category.color, 1);
    }

    enable() {
        this.container.cursor = 'pointer';
        this.isEnable = true;
        this.enableSeat();

        this.entityLabel.setValue('');
    }

    disable(options) {
        options = options || { reason: null };
        this.container.cursor = 'not-allowed';
        this.isEnable = false;
        this.disableSeat();

        if (options && options.reason) this.entityLabel.setValue(options.reason);
    }

    addTicket() {
        this.setTickets(this.countTicket + 1);
    }

    removeTicket() {
        this.setTickets(this.countTicket - 1);
    }

    setTickets(count) {
        if (count < 0) return;

        this.countTicket = count;
        this.updateTickets();
    }

    updateTickets() {
        this.countText.text = `x${this.countTicket}`;
    }
}